import React, { useState } from "react";
import { Grid, Stack } from "@mui/material";
import Radio from "@mui/material/Radio";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/system";

interface IRadioGroupProps {
  item: any;
  selectedValue: string;
  onChange: (value: string) => void;
}

const RadioGroup = ({ item, selectedValue, onChange }: IRadioGroupProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  return (
    <Grid container columnSpacing={4}>
      <Grid item xs={5}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography>{item?.question}</Typography>
        </Box>
      </Grid>
      <Grid item xs={7}>
        <Stack direction={"row"} justifyContent={"space-around"}>
          <Radio
            checked={selectedValue === "1"}
            onChange={handleChange}
            value="1"
            name="radio-buttons"
            inputProps={{ "aria-label": "1" }}
          />
          <Radio
            checked={selectedValue === "2"}
            onChange={handleChange}
            value="2"
            name="radio-buttons"
            inputProps={{ "aria-label": "2" }}
          />
          <Radio
            checked={selectedValue === "3"}
            onChange={handleChange}
            value="3"
            name="radio-buttons"
            inputProps={{ "aria-label": "3" }}
          />
          <Radio
            checked={selectedValue === "4"}
            onChange={handleChange}
            value="4"
            name="radio-buttons"
            inputProps={{ "aria-label": "4" }}
          />
        </Stack>
      </Grid>
    </Grid>
  );
};

export default RadioGroup;
